// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Chip} from '@material-ui/core';
import {colors} from '../../../assets/styles/colors';
import {classNames} from '../../../utils/react';

type Props = {
  text: string,
  selected?: boolean,
  handleOnClick: (id: any) => void,
  id: string,
  disabled?: boolean,
  classes?: {
    root?: string,
    outlined?: string,
    icon?: string,
  },
};

export const useStyles = makeStyles(theme => ({
  // button: {
  //   padding: theme.spacing(0.375, 2),
  //   marginRight: theme.spacing(1),
  //   '&:last-child': {
  //     marginRight: theme.spacing(0),
  //   },
  // },
  // optionText: {
  //   textTransform: 'none',
  // },
  // selected: {
  //   fontWeight: 600,
  // },
  customChip: {
    color: colors.grey800,
    fontSize: '0.875rem',
    // marginRight: 10,
    '&:not(:nth-last-child(2))': {
      marginRight: 10,
    },
    // minWidth: 0,
  },
  outlined: {
    backgroundColor: 'white',
    border: '1px solid #E8E8ED',
  },
  selected: {
    color: colors.purple3,
    fontWeight: 600,
    backgroundColor: colors.lightPurple,
    border: `1px solid ${colors.purple3}`,
  },
  icon: {
    fontSize: '1rem',
    margin: '0 -2px 0 12px',
  },
}));

export default function FilterButton(props: Props) {
  const {text, selected, handleOnClick, id, disabled} = props;
  const classes = useStyles();

  return (
    // <Button
    //   onClick={handleOnClick}
    //   variant="outlined"
    //   className={classes.button}
    // >
    //   <Typography
    //     variant="body1"
    //     className={`${classes.optionText} ${selected ? classes.selected : ''}`}
    //   >
    //     {text}
    //   </Typography>
    // </Button>
    <Chip
      classes={{
        /* `${} ${selected ? classes.selected : ''}` */
        root: classNames(classes.customChip, props?.classes?.root, {
          [classes.selected]: selected,
        }),
        // outlined: `${classes.outlined} ${selected ? classes.selected : ''}`,
        outlined: classNames(classes.outlined, props?.classes?.outlined, {
          [classes.selected]: selected,
        }),
        icon: classNames(classes.icon, props?.classes?.icon),
      }}
      label={text}
      clickable
      color={selected ? 'primary' : 'default'}
      variant={'outlined'}
      onClick={() => handleOnClick(id)}
      onDelete={selected ? () => handleOnClick(id) : null}
      disabled={disabled}
    />
  );
}

FilterButton.propTypes = {
  text: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  handleOnClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};
